import DynamicFormFieldModelBase from '../_generated/modelBases/dynamic-form-field-model-base';

export default class DynamicFormFieldModel extends DynamicFormFieldModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
